var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    transform: "scale(.7)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.84,461.93l-46.61,2c-18.27.79-37.72-2.33-55.31,2.65l-2,.54c-2.88,9.21,71.3,8.14,107,3.95,4.8-.57,10.1-1.48,13.12-5.26C394,461.72,387.56,461.69,381.84,461.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,173.07s0-.26,0-.75,0-1.23,0-2.18c0-1.92,0-4.74,0-8.36C85,154.52,85,144,85,131c0-26-.06-62.13-.09-102.45l.22.22H75.79l.22-.22c-.07,67-.12,124-.15,144.53l-.07-.08,7,0h1.74l.59,0h-.56l-1.73,0-7,0h-.08v-.07c0-20.56-.08-77.52-.15-144.53v-.23h9.75v.23c0,40.38-.07,76.54-.1,102.61,0,13,0,23.49-.07,30.74,0,3.6,0,6.4,0,8.31,0,.94,0,1.65,0,2.15S85.08,173.07,85.08,173.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.39,173.07s0-.26,0-.75,0-1.23,0-2.18c0-1.92,0-4.74,0-8.36,0-7.27,0-17.77-.07-30.8,0-26-.06-62.13-.09-102.44l.22.22h-9l.23-.22c-.07,67.21-.13,124.29-.15,144.53l-.08-.08,6.75,0h1.68l.57,0h-.54l-1.67,0-6.79,0h-.07v-.07c0-20.24-.08-77.32-.15-144.53v-.23h9.45v.23c0,40.37-.07,76.53-.1,102.61,0,13-.05,23.49-.06,30.74,0,3.6,0,6.4,0,8.31,0,.93,0,1.65,0,2.15S136.39,173.07,136.39,173.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17,85.08c0,.13-24.44.23-54.59.23S51,85.21,51,85.08s24.44-.22,54.6-.22S160.17,85,160.17,85.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17,68c0,.13-24.44.23-54.59.23S51,68.16,51,68s24.44-.22,54.6-.22S160.17,67.91,160.17,68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17,51c0,.13-24.44.23-54.59.23S51,51.11,51,51s24.44-.23,54.6-.23S160.17,50.86,160.17,51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17,33.93c0,.12-24.44.22-54.59.22S51,34.05,51,33.93s24.44-.23,54.6-.23S160.17,33.8,160.17,33.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25,86a7.11,7.11,0,1,1-7.1-7.11A7.1,7.1,0,0,1,59.25,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.15,93.54A7.55,7.55,0,1,1,59.69,86,7.55,7.55,0,0,1,52.15,93.54Zm0-14.22A6.68,6.68,0,1,0,58.82,86,6.69,6.69,0,0,0,52.15,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.31,86a7.11,7.11,0,1,1-7.1-7.11A7.1,7.1,0,0,1,77.31,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.21,93.54A7.55,7.55,0,1,1,77.75,86,7.55,7.55,0,0,1,70.21,93.54Zm0-14.22A6.68,6.68,0,1,0,76.88,86,6.69,6.69,0,0,0,70.21,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,86a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,95.37,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,93.54A7.55,7.55,0,1,1,95.81,86,7.55,7.55,0,0,1,88.26,93.54Zm0-14.22A6.68,6.68,0,1,0,94.94,86,6.69,6.69,0,0,0,88.26,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,86a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,113.43,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.32,93.54A7.55,7.55,0,1,1,113.87,86,7.55,7.55,0,0,1,106.32,93.54Zm0-14.22A6.68,6.68,0,1,0,113,86,6.68,6.68,0,0,0,106.32,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.49,86a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,131.49,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,93.54A7.55,7.55,0,1,1,131.93,86,7.55,7.55,0,0,1,124.38,93.54Zm0-14.22A6.68,6.68,0,1,0,131.06,86,6.68,6.68,0,0,0,124.38,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.55,86a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,149.55,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.44,93.54A7.55,7.55,0,1,1,150,86,7.55,7.55,0,0,1,142.44,93.54Zm0-14.22A6.68,6.68,0,1,0,149.12,86,6.68,6.68,0,0,0,142.44,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.61,86a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,167.61,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,93.54A7.55,7.55,0,1,1,168,86,7.55,7.55,0,0,1,160.5,93.54Zm0-14.22A6.68,6.68,0,1,0,167.17,86,6.68,6.68,0,0,0,160.5,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.31,68.49a7.11,7.11,0,1,1-7.1-7.1A7.1,7.1,0,0,1,77.31,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.21,76a7.55,7.55,0,1,1,7.54-7.55A7.56,7.56,0,0,1,70.21,76Zm0-14.22a6.68,6.68,0,1,0,6.67,6.67A6.68,6.68,0,0,0,70.21,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,95.37,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,76a7.55,7.55,0,1,1,7.55-7.55A7.56,7.56,0,0,1,88.26,76Zm0-14.22a6.68,6.68,0,1,0,6.68,6.67A6.68,6.68,0,0,0,88.26,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,113.43,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.32,76a7.55,7.55,0,1,1,7.55-7.55A7.55,7.55,0,0,1,106.32,76Zm0-14.22A6.68,6.68,0,1,0,113,68.49,6.67,6.67,0,0,0,106.32,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.49,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,131.49,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,76a7.55,7.55,0,1,1,7.55-7.55A7.55,7.55,0,0,1,124.38,76Zm0-14.22a6.68,6.68,0,1,0,6.68,6.67A6.67,6.67,0,0,0,124.38,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.55,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,149.55,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.44,76A7.55,7.55,0,1,1,150,68.49,7.55,7.55,0,0,1,142.44,76Zm0-14.22a6.68,6.68,0,1,0,6.68,6.67A6.67,6.67,0,0,0,142.44,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.61,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,167.61,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,76A7.55,7.55,0,1,1,168,68.49,7.55,7.55,0,0,1,160.5,76Zm0-14.22a6.68,6.68,0,1,0,6.67,6.67A6.67,6.67,0,0,0,160.5,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25,68.3a7.11,7.11,0,1,1-7.1-7.11A7.1,7.1,0,0,1,59.25,68.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.15,75.84a7.55,7.55,0,1,1,7.54-7.55A7.56,7.56,0,0,1,52.15,75.84Zm0-14.22a6.68,6.68,0,1,0,6.67,6.67A6.69,6.69,0,0,0,52.15,61.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.21,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.21,58.75a7.55,7.55,0,1,1,7.54-7.54A7.55,7.55,0,0,1,70.21,58.75Zm0-14.22a6.68,6.68,0,1,0,6.67,6.68A6.69,6.69,0,0,0,70.21,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88.26,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,58.75a7.55,7.55,0,1,1,7.55-7.54A7.55,7.55,0,0,1,88.26,58.75Zm0-14.22a6.68,6.68,0,1,0,6.68,6.68A6.69,6.69,0,0,0,88.26,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.32,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.32,58.75a7.55,7.55,0,1,1,7.55-7.54A7.55,7.55,0,0,1,106.32,58.75Zm0-14.22A6.68,6.68,0,1,0,113,51.21,6.68,6.68,0,0,0,106.32,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.49,51.21a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,131.49,51.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,58.75a7.55,7.55,0,1,1,7.55-7.54A7.55,7.55,0,0,1,124.38,58.75Zm0-14.22a6.68,6.68,0,1,0,6.68,6.68A6.68,6.68,0,0,0,124.38,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.44,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.44,58.75A7.55,7.55,0,1,1,150,51.21,7.55,7.55,0,0,1,142.44,58.75Zm0-14.22a6.68,6.68,0,1,0,6.68,6.68A6.68,6.68,0,0,0,142.44,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.5,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,58.75A7.55,7.55,0,1,1,168,51.21,7.55,7.55,0,0,1,160.5,58.75Zm0-14.22a6.68,6.68,0,1,0,6.67,6.68A6.68,6.68,0,0,0,160.5,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.15,
    cy: 51.01,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.15,58.55A7.54,7.54,0,1,1,59.69,51,7.55,7.55,0,0,1,52.15,58.55Zm0-14.22A6.68,6.68,0,1,0,58.82,51,6.69,6.69,0,0,0,52.15,44.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.31,33.92a7.11,7.11,0,1,1-7.1-7.11A7.11,7.11,0,0,1,77.31,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.21,41.46a7.54,7.54,0,1,1,7.54-7.54A7.55,7.55,0,0,1,70.21,41.46Zm0-14.21a6.67,6.67,0,1,0,6.67,6.67A6.68,6.68,0,0,0,70.21,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.37,33.92a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,95.37,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.26,41.46a7.54,7.54,0,1,1,7.55-7.54A7.55,7.55,0,0,1,88.26,41.46Zm0-14.21a6.67,6.67,0,1,0,6.68,6.67A6.68,6.68,0,0,0,88.26,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.43,33.92a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,113.43,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.32,41.46a7.54,7.54,0,1,1,7.55-7.54A7.55,7.55,0,0,1,106.32,41.46Zm0-14.21A6.67,6.67,0,1,0,113,33.92,6.67,6.67,0,0,0,106.32,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.49,33.92a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,131.49,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38,41.46a7.54,7.54,0,1,1,7.55-7.54A7.55,7.55,0,0,1,124.38,41.46Zm0-14.21a6.67,6.67,0,1,0,6.68,6.67A6.67,6.67,0,0,0,124.38,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.55,33.92a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,149.55,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.44,41.46A7.54,7.54,0,1,1,150,33.92,7.55,7.55,0,0,1,142.44,41.46Zm0-14.21a6.67,6.67,0,1,0,6.68,6.67A6.67,6.67,0,0,0,142.44,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.61,33.92a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,167.61,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.5,41.46A7.54,7.54,0,1,1,168,33.92,7.55,7.55,0,0,1,160.5,41.46Zm0-14.21a6.67,6.67,0,1,0,6.67,6.67A6.67,6.67,0,0,0,160.5,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25,33.72a7.11,7.11,0,1,1-7.1-7.11A7.1,7.1,0,0,1,59.25,33.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.15,41.26a7.54,7.54,0,1,1,7.54-7.54A7.55,7.55,0,0,1,52.15,41.26Zm0-14.21a6.67,6.67,0,1,0,6.67,6.67A6.68,6.68,0,0,0,52.15,27.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.21,173.07s0-.26,0-.75,0-1.23,0-2.18c0-1.92,0-4.74,0-8.36,0-7.26,0-17.77-.07-30.79,0-26-.05-62.13-.09-102.45l.22.22h-9.29l.23-.22c-.07,67-.13,124-.15,144.53l-.08-.08,7,0h1.74l.59,0h-.56l-1.73,0-7,0h-.07v-.07c0-20.56-.08-77.52-.16-144.53v-.23h9.75v.23c0,40.38-.07,76.54-.09,102.61,0,13-.06,23.49-.07,30.74,0,3.6,0,6.4,0,8.31,0,.94,0,1.65,0,2.15S313.21,173.07,313.21,173.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.53,173.07s0-.26,0-.75,0-1.23,0-2.18c0-1.92,0-4.74,0-8.36,0-7.27,0-17.77-.07-30.8,0-26-.05-62.13-.09-102.44l.23.22h-9l.23-.22c-.07,67.21-.13,124.29-.15,144.53l-.08-.08,6.75,0H364l.57,0H364l-1.66,0-6.8,0h-.07v-.07c0-20.24-.08-77.32-.15-144.53v-.23h9.45v.23c0,40.37-.07,76.53-.09,102.61,0,13-.05,23.49-.07,30.74,0,3.6,0,6.4,0,8.31,0,.93,0,1.65,0,2.15S364.53,173.07,364.53,173.07Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,85.08c0,.13-24.44.23-54.59.23s-54.59-.1-54.59-.23,24.44-.22,54.59-.22S388.3,85,388.3,85.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,68c0,.13-24.44.23-54.59.23s-54.59-.1-54.59-.23,24.44-.22,54.59-.22S388.3,67.91,388.3,68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,51c0,.13-24.44.23-54.59.23s-54.59-.1-54.59-.23,24.44-.23,54.59-.23S388.3,50.86,388.3,51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.3,33.93c0,.12-24.44.22-54.59.22s-54.59-.1-54.59-.22,24.44-.23,54.59-.23S388.3,33.8,388.3,33.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,86a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,287.39,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28,93.54A7.55,7.55,0,1,1,287.82,86,7.55,7.55,0,0,1,280.28,93.54Zm0-14.22A6.68,6.68,0,1,0,287,86,6.68,6.68,0,0,0,280.28,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45,86a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,305.45,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,93.54A7.55,7.55,0,1,1,305.88,86,7.55,7.55,0,0,1,298.34,93.54Zm0-14.22A6.68,6.68,0,1,0,305,86,6.69,6.69,0,0,0,298.34,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.51,86a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,323.51,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,93.54A7.55,7.55,0,1,1,323.94,86,7.55,7.55,0,0,1,316.4,93.54Zm0-14.22A6.68,6.68,0,1,0,323.07,86,6.69,6.69,0,0,0,316.4,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,86a7.11,7.11,0,1,1-7.1-7.11A7.1,7.1,0,0,1,341.56,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46,93.54A7.55,7.55,0,1,1,342,86,7.55,7.55,0,0,1,334.46,93.54Zm0-14.22A6.68,6.68,0,1,0,341.13,86,6.69,6.69,0,0,0,334.46,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62,86a7.11,7.11,0,1,1-7.1-7.11A7.1,7.1,0,0,1,359.62,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,93.54A7.55,7.55,0,1,1,360.06,86,7.55,7.55,0,0,1,352.52,93.54Zm0-14.22A6.68,6.68,0,1,0,359.19,86,6.69,6.69,0,0,0,352.52,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,86a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,377.68,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.58,93.54A7.55,7.55,0,1,1,378.12,86,7.55,7.55,0,0,1,370.58,93.54Zm0-14.22A6.68,6.68,0,1,0,377.25,86,6.69,6.69,0,0,0,370.58,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,86a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,395.74,86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.63,93.54A7.55,7.55,0,1,1,396.18,86,7.55,7.55,0,0,1,388.63,93.54Zm0-14.22A6.68,6.68,0,1,0,395.31,86,6.68,6.68,0,0,0,388.63,79.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,305.45,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,76a7.55,7.55,0,1,1,7.54-7.55A7.55,7.55,0,0,1,298.34,76Zm0-14.22A6.68,6.68,0,1,0,305,68.49,6.68,6.68,0,0,0,298.34,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.51,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,323.51,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,76a7.55,7.55,0,1,1,7.54-7.55A7.55,7.55,0,0,1,316.4,76Zm0-14.22a6.68,6.68,0,1,0,6.67,6.67A6.68,6.68,0,0,0,316.4,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,68.49a7.11,7.11,0,1,1-7.1-7.1A7.1,7.1,0,0,1,341.56,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46,76A7.55,7.55,0,1,1,342,68.49,7.56,7.56,0,0,1,334.46,76Zm0-14.22a6.68,6.68,0,1,0,6.67,6.67A6.68,6.68,0,0,0,334.46,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62,68.49a7.11,7.11,0,1,1-7.1-7.1A7.1,7.1,0,0,1,359.62,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,76a7.55,7.55,0,1,1,7.54-7.55A7.56,7.56,0,0,1,352.52,76Zm0-14.22a6.68,6.68,0,1,0,6.67,6.67A6.68,6.68,0,0,0,352.52,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,377.68,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.58,76a7.55,7.55,0,1,1,7.54-7.55A7.56,7.56,0,0,1,370.58,76Zm0-14.22a6.68,6.68,0,1,0,6.67,6.67A6.68,6.68,0,0,0,370.58,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,68.49a7.11,7.11,0,1,1-7.11-7.1A7.11,7.11,0,0,1,395.74,68.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.63,76a7.55,7.55,0,1,1,7.55-7.55A7.55,7.55,0,0,1,388.63,76Zm0-14.22a6.68,6.68,0,1,0,6.68,6.67A6.67,6.67,0,0,0,388.63,61.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,68.3a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,287.39,68.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28,75.84a7.55,7.55,0,1,1,7.54-7.55A7.55,7.55,0,0,1,280.28,75.84Zm0-14.22A6.68,6.68,0,1,0,287,68.29,6.68,6.68,0,0,0,280.28,61.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.34,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,58.75a7.55,7.55,0,1,1,7.54-7.54A7.55,7.55,0,0,1,298.34,58.75Zm0-14.22A6.68,6.68,0,1,0,305,51.21,6.69,6.69,0,0,0,298.34,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.4,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,58.75a7.55,7.55,0,1,1,7.54-7.54A7.55,7.55,0,0,1,316.4,58.75Zm0-14.22a6.68,6.68,0,1,0,6.67,6.68A6.69,6.69,0,0,0,316.4,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,51.21a7.11,7.11,0,1,1-7.1-7.11A7.1,7.1,0,0,1,341.56,51.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46,58.75A7.55,7.55,0,1,1,342,51.21,7.55,7.55,0,0,1,334.46,58.75Zm0-14.22a6.68,6.68,0,1,0,6.67,6.68A6.69,6.69,0,0,0,334.46,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 352.52,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,58.75a7.55,7.55,0,1,1,7.54-7.54A7.55,7.55,0,0,1,352.52,58.75Zm0-14.22a6.68,6.68,0,1,0,6.67,6.68A6.69,6.69,0,0,0,352.52,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 370.58,
    cy: 51.21,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.58,58.75a7.55,7.55,0,1,1,7.54-7.54A7.55,7.55,0,0,1,370.58,58.75Zm0-14.22a6.68,6.68,0,1,0,6.67,6.68A6.69,6.69,0,0,0,370.58,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,51.21a7.11,7.11,0,1,1-7.11-7.11A7.1,7.1,0,0,1,395.74,51.21Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.63,58.75a7.55,7.55,0,1,1,7.55-7.54A7.55,7.55,0,0,1,388.63,58.75Zm0-14.22a6.68,6.68,0,1,0,6.68,6.68A6.68,6.68,0,0,0,388.63,44.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.28,
    cy: 51.01,
    r: 7.11,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28,58.55A7.54,7.54,0,1,1,287.82,51,7.55,7.55,0,0,1,280.28,58.55Zm0-14.22A6.68,6.68,0,1,0,287,51,6.68,6.68,0,0,0,280.28,44.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.45,33.92a7.11,7.11,0,1,1-7.11-7.11A7.12,7.12,0,0,1,305.45,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.34,41.46a7.54,7.54,0,1,1,7.54-7.54A7.55,7.55,0,0,1,298.34,41.46Zm0-14.21A6.67,6.67,0,1,0,305,33.92,6.68,6.68,0,0,0,298.34,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.51,33.92a7.11,7.11,0,1,1-7.11-7.11A7.12,7.12,0,0,1,323.51,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.4,41.46a7.54,7.54,0,1,1,7.54-7.54A7.55,7.55,0,0,1,316.4,41.46Zm0-14.21a6.67,6.67,0,1,0,6.67,6.67A6.68,6.68,0,0,0,316.4,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.56,33.92a7.11,7.11,0,1,1-7.1-7.11A7.11,7.11,0,0,1,341.56,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46,41.46A7.54,7.54,0,1,1,342,33.92,7.55,7.55,0,0,1,334.46,41.46Zm0-14.21a6.67,6.67,0,1,0,6.67,6.67A6.68,6.68,0,0,0,334.46,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.62,33.92a7.11,7.11,0,1,1-7.1-7.11A7.11,7.11,0,0,1,359.62,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,41.46a7.54,7.54,0,1,1,7.54-7.54A7.55,7.55,0,0,1,352.52,41.46Zm0-14.21a6.67,6.67,0,1,0,6.67,6.67A6.68,6.68,0,0,0,352.52,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.68,33.92a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,377.68,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.58,41.46a7.54,7.54,0,1,1,7.54-7.54A7.55,7.55,0,0,1,370.58,41.46Zm0-14.21a6.67,6.67,0,1,0,6.67,6.67A6.68,6.68,0,0,0,370.58,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.74,33.92a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,395.74,33.92Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.63,41.46a7.54,7.54,0,1,1,7.55-7.54A7.55,7.55,0,0,1,388.63,41.46Zm0-14.21a6.67,6.67,0,1,0,6.68,6.67A6.67,6.67,0,0,0,388.63,27.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.39,33.72a7.11,7.11,0,1,1-7.11-7.11A7.11,7.11,0,0,1,287.39,33.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.28,41.26a7.54,7.54,0,1,1,7.54-7.54A7.55,7.55,0,0,1,280.28,41.26Zm0-14.21A6.67,6.67,0,1,0,287,33.72,6.67,6.67,0,0,0,280.28,27.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.61,
    y: 153.63,
    width: 94.33,
    height: 138.19,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.97,
    y: 157.67,
    width: 78.86,
    height: 18.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.93 153.63 463.63 176.09 477.83 176.09 477.83 153.63 471.93 153.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.97,
    y: 180.13,
    width: 78.86,
    height: 18.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.93 176.09 463.63 198.55 477.83 198.55 477.83 176.09 471.93 176.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.97,
    y: 203.02,
    width: 78.86,
    height: 18.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.93 198.99 463.63 221.45 477.83 221.45 477.83 198.99 471.93 198.99",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.97,
    y: 225.45,
    width: 78.86,
    height: 18.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.93 221.41 463.63 243.87 477.83 243.87 477.83 221.41 471.93 221.41",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.97,
    y: 247.87,
    width: 78.86,
    height: 18.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.93 243.84 463.63 266.3 477.83 266.3 477.83 243.84 471.93 243.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.97,
    y: 270.3,
    width: 78.86,
    height: 18.42,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "471.93 266.26 463.63 288.72 477.83 288.72 477.83 266.26 471.93 266.26",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.85,
    y: 213.67,
    width: 376.76,
    height: 4.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.85,
    y: 218.3,
    width: 376.76,
    height: 31.82,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.17,
    y: 253.52,
    width: 376.76,
    height: 31.82,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.85,
    y: 170.26,
    width: 376.76,
    height: 43.24,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.85,
    y: 166.3,
    width: 376.76,
    height: 4.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.17,
    y: 248.81,
    width: 376.76,
    height: 4.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.17,
    y: 284.2,
    width: 470.77,
    height: 78.93,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485.8,363.69c0,.14-105.58.26-235.79.26s-235.81-.12-235.81-.26,105.56-.26,235.81-.26S485.8,363.55,485.8,363.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.56,349.33a7.88,7.88,0,0,1,1.52,1.82,24.54,24.54,0,0,1,4.09,10.61,8.13,8.13,0,0,1,.11,2.37,51.17,51.17,0,0,0-2-7.73A50,50,0,0,0,82.56,349.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.23,334.59a5.93,5.93,0,0,1,.09,1.15c0,.84.05,1.88.08,3.11.08,2.63.23,6.25.54,10.25s.74,7.6,1.08,10.21c.16,1.21.29,2.24.4,3.08a5.15,5.15,0,0,1,.1,1.15,4.77,4.77,0,0,1-.3-1.11c-.15-.72-.35-1.77-.56-3.07-.44-2.6-.92-6.21-1.24-10.22s-.4-7.65-.38-10.29c0-1.31,0-2.38.08-3.12A4.25,4.25,0,0,1,89.23,334.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.13,354.5c.15.06-.59,1.91-.83,4.32s.09,4.37-.07,4.4a11.19,11.19,0,0,1,.9-8.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8,355.7a3.34,3.34,0,0,1,1.45.64A9.49,9.49,0,0,1,355,359a9.75,9.75,0,0,1,1.52,3.53,3.49,3.49,0,0,1,.08,1.58,17,17,0,0,0-2-4.82A16.61,16.61,0,0,0,350.8,355.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.2,336.7a4.34,4.34,0,0,1,.08,1.09q0,1.23.06,3c.07,2.5.26,6,.7,9.75s1.06,7.2,1.57,9.65c.25,1.14.45,2.11.62,2.9a4.7,4.7,0,0,1,.18,1.08,4.12,4.12,0,0,1-.38-1c-.21-.67-.48-1.65-.78-2.87a81.56,81.56,0,0,1-1.73-9.67,80,80,0,0,1-.54-9.8c0-1.26,0-2.28.09-3A4.28,4.28,0,0,1,357.2,336.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.22,354.16a31,31,0,0,0-.8,4.83,30,30,0,0,0,.48,4.86,8.74,8.74,0,0,1-1-4.88A8.89,8.89,0,0,1,365.22,354.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.53,363.79a24.21,24.21,0,0,1-1.64-5.37,23.25,23.25,0,0,1-.83-5.55,45.77,45.77,0,0,1,1.34,5.43A40.66,40.66,0,0,1,462.53,363.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466,355.92c.14.05-.38,1.83-.74,4.07a40.68,40.68,0,0,1-.58,4.1,10.57,10.57,0,0,1,.07-4.18A10.12,10.12,0,0,1,466,355.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,420.94a15.09,15.09,0,0,1-1.64-2.19c-1-1.39-2.31-3.29-3.86-5.34s-3-3.88-4.06-5.19A16.57,16.57,0,0,1,37.82,406,12.43,12.43,0,0,1,39.75,408c1.14,1.26,2.64,3,4.2,5.11s2.86,4,3.75,5.45A14.27,14.27,0,0,1,49,420.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,422.15a99.2,99.2,0,0,1-3.52-9.75c-1.81-5.43-3.16-9.88-3-9.92a102,102,0,0,1,3.52,9.76C51,417.67,52.33,422.11,52.2,422.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.16,406.39a10.24,10.24,0,0,1,0,2.32c0,1.63-.09,3.51-.14,5.58s0,3.95-.07,5.58a10.34,10.34,0,0,1-.11,2.32,9.8,9.8,0,0,1-.25-2.31c-.09-1.43-.13-3.41-.09-5.6s.16-4.17.29-5.59A10.06,10.06,0,0,1,55.16,406.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.82,417.31a8.81,8.81,0,0,1,1.6,1.71,39.89,39.89,0,0,1,5.74,9.65,8.8,8.8,0,0,1,.74,2.22c-.15.06-1.47-3.24-3.71-7S143.7,417.41,143.82,417.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.71,408.35a87,87,0,0,1,1.5,9.44,88.41,88.41,0,0,1,1,9.51,87,87,0,0,1-1.5-9.44A88.41,88.41,0,0,1,150.71,408.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.64,417a46.92,46.92,0,0,1-4.74,8.69,46.92,46.92,0,0,1,4.74-8.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.79,408.34c-.13.07-1.87-2.83-4.19-6.29s-4.34-6.17-4.23-6.27a8.52,8.52,0,0,1,1.5,1.65c.86,1.07,2,2.59,3.16,4.33s2.14,3.37,2.8,4.57A8.27,8.27,0,0,1,420.79,408.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.75,406a27.2,27.2,0,0,1-1-6.68,27.57,27.57,0,0,1,.16-6.75c.15,0,.13,3,.36,6.71S422.9,406,422.75,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.31,397a30.81,30.81,0,0,0-2.4,5.08,29.32,29.32,0,0,0-.89,5.54A12.41,12.41,0,0,1,428.31,397Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.79,469.18a40.49,40.49,0,0,0-7.27-14.55,8.88,8.88,0,0,1,1.68,1.75,27.35,27.35,0,0,1,3.16,4.92,27.64,27.64,0,0,1,2,5.48A8.52,8.52,0,0,1,241.79,469.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.35,469.18a14.12,14.12,0,0,1-.6-2.59c-.32-1.61-.76-3.83-1.29-6.27s-1.05-4.64-1.43-6.24a15.18,15.18,0,0,1-.52-2.61,13.34,13.34,0,0,1,.88,2.52c.47,1.57,1,3.77,1.58,6.22s.91,4.69,1.14,6.32A12.2,12.2,0,0,1,245.35,469.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,448.65a29.43,29.43,0,0,1-.46,3.12,54.66,54.66,0,0,0-.57,7.56,53.36,53.36,0,0,0,.55,7.55c.27,1.92.52,3.11.44,3.12s-.14-.27-.29-.8-.33-1.3-.52-2.26a40.91,40.91,0,0,1,0-15.23c.19-1,.37-1.73.53-2.26A2.45,2.45,0,0,1,250,448.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.08,75.19l-8.5-.09L342,77.52s-15.34,1.76-17.3,3.61L302.19,102.4l-26.45,15.34,11.63,18,26.27-18.07,21-30.15S340.24,92,343.74,91a28.66,28.66,0,0,1,6.73-1.32c.64,0,8.26-1.46,8.26-1.46a1.86,1.86,0,0,0-1.33-1.72c-1.4-.56-7.82-.47-8.21-.53a2.93,2.93,0,0,1-2-1.45c0-.06,0-.11,0-.17a.77.77,0,0,1,0-.15,6.15,6.15,0,0,1,.1-2.18l-.12,1.81,2.79-2.48h5.46l2.24,3s1.84-.24,1.58-1.31a26.63,26.63,0,0,0-2.36-4.2l-3.27-.76.18-.16c1.8,0,5.68-.07,6.58-.62C361.88,76.37,360.08,75.19,360.08,75.19Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.86,113.84a7.33,7.33,0,0,1-2.64-3.14,7.19,7.19,0,0,1-1-4c.16,0,.44,1.78,1.45,3.75S308,113.72,307.86,113.84Z",
    style: {
      fill: "#723c31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.68,79.86c.09-.75.09-1.7-.59-2a1.76,1.76,0,0,0-.82-.14,20.82,20.82,0,0,0-3.7.28,2.7,2.7,0,0,1-1.13,0c-.43-.11-.78-.44-1.21-.56-1.66-.47-3.19,2.26-4.71,1.45-1.19-.63-.65-2.58-1.51-3.61-.73-.88-2.16-.75-3.06-1.46a8.12,8.12,0,0,1-1.23-1.66c-.65-.87-1.67-1.5-2-2.53a10.08,10.08,0,0,1-.2-1.74,2.49,2.49,0,0,0-1.25-1.44l.72.06c.8,0,1.85.24,1.88,1a2,2,0,0,1,2.2-.28,6.56,6.56,0,0,0,2.24.7c.45,0,.9-.16,1.35-.13a3.49,3.49,0,0,1,2.24,1.53c.54-.85,1.8-.81,2.74-.45a6.76,6.76,0,0,0,2.87.86c1-.09,1.9-1.38,1.19-2.09-1.52-.94-3.82,0-5.09-1.24-.34-.33-.59-.81-1.06-.91-.24,0-.49,0-.73,0-.7-.09-1.11-.9-1.8-1.06s-1.19.24-1.76.09c-.75-.21-1.1-1.24-1.87-1.34-.47-.06-.91.26-1.39.32-1.24.17-2.17-1.4-3.43-1.35-.81,0-1.5.74-2.3.69a2.66,2.66,0,0,1-1.51-.85,8.22,8.22,0,0,0-2.54-1.52,10.85,10.85,0,0,0-4.2-.66,3.13,3.13,0,0,1,.15-.32,1.36,1.36,0,0,1,1-.52,30,30,0,0,1,7.68-.56,2.33,2.33,0,0,0,1.59-.28c.37-.29.58-.83,1-.89s.67.23,1,.32c1.17.3,2.25-1.42,3.35-.94.31.14.55.43.88.45.49,0,.78-.52,1.2-.77a2.7,2.7,0,0,1,2,.07c.67.15,1.56.07,1.78-.57a1.26,1.26,0,0,0-.73-1.38,2.87,2.87,0,0,0-2.07-.31,3.38,3.38,0,0,1-1.12.22c-.61-.07-1.07-.66-1.69-.74-1-.11-1.86,1.18-2.8.83-.37-.14-.63-.51-1-.62-1.08-.31-2,1.66-3,1.11-.37-.21-.53-.72-.94-.83-.8-.22-1,1.17-1.75,1.56s-1.62-.49-2.51-.55c-1.37-.09-2.27,1.87-3.63,1.69a5.42,5.42,0,0,1-1.25-.52,2.47,2.47,0,0,0-2.69.63,4.12,4.12,0,0,1-.79.87c-.83.51-1.92-.23-2.86,0-1.31.32-1.73,2.27-3.06,2.48a3.62,3.62,0,0,1-1.26-.14,4.36,4.36,0,0,0-1.25,0,7.63,7.63,0,0,1,2.18-4.74,14.78,14.78,0,0,1,3-2.15,5.35,5.35,0,0,1,1.2-.59,6.06,6.06,0,0,1,.95-.15,17.88,17.88,0,0,0,2.82-.59,2.81,2.81,0,0,0,.85-.37,1.4,1.4,0,1,0-2.22-1.37,1.18,1.18,0,0,0-1.79-.39c-.3.29-.45.74-.82.94s-1-.05-1.6-.11a1.86,1.86,0,0,0-1.93,2.1,1.49,1.49,0,0,0-2.09.54,2.26,2.26,0,0,0,.22,2.33,1.81,1.81,0,0,0-2.37,1c-.21.56-.14,1.24-.54,1.69a5.76,5.76,0,0,1-.53.42c-.91.72-.9,2-.56,3.19a4.7,4.7,0,0,0-.9,1.58l-.19,0a4.08,4.08,0,0,0-4.47,1.26,15.65,15.65,0,0,1-1.18,1.46c-.89.8-2.19.92-2.91,1.9-.35.47-.53,1.11-1,1.47a4.38,4.38,0,0,1-1.26.48,3,3,0,0,0-1.71,2.87v0s0,0,0,0a2.86,2.86,0,0,0,.24,1.13,1.67,1.67,0,0,1-1.26,1.42c-.62.12-1.35-.1-1.81.32s-.15,1.62-.61,2.29c-.58.85-2.15.42-2.73,1.27s0,2.09-.9,2.33c-.19,0-.41,0-.56.14s-.07.67-.14,1c-.15.77-1.43.65-1.85,1.31-.32.49,0,1.12.15,1.69s-.16,1.4-.72,1.26c.54.1.79.75.83,1.31a3,3,0,0,0,.31,1.61,5.4,5.4,0,0,1,.43.52,1.79,1.79,0,0,1,.11,1.1c-.11.9-.21,1.81-.32,2.71s.15,2.08,1,2c.29,0,.57-.25.85-.17s.4.37.66.45c.6.19.79-.78.7-1.4a8.52,8.52,0,0,1,.55-4.41,4.32,4.32,0,0,0,.39-1.2,8.14,8.14,0,0,0-.52-2.18c-.32-1.54.61-3,1.49-4.34A13.59,13.59,0,0,1,214,80.3a16,16,0,0,1,1.64-1.15,3.67,3.67,0,0,0-.61,1.95,1.94,1.94,0,0,1,0,.8,1.18,1.18,0,0,1-.48.46c-1,.67-1.95,2-1.51,3.27.17.45.49.82.63,1.28a13.43,13.43,0,0,1,.15,1.69,5.38,5.38,0,0,0,.31,1l.52,1.29a10.18,10.18,0,0,0,1.84,3.29,2.39,2.39,0,0,1,.62.79c.13.35.07.75.17,1.11a2.13,2.13,0,0,0,1.3,1.19l5.05,2.37a2.83,2.83,0,0,0,1.14.34c.36,0,.7-.16,1.05-.19,1.06-.1,2,.9,3.05,1A2.16,2.16,0,0,0,231,99.32l-.8-15.25.92-5.47,3.51-4.79,16-6.33,8,11.15a21.11,21.11,0,0,0,5,2.59,2.39,2.39,0,0,0,1.36.2c.52-.14.95-.6,1.49-.57s.83.39,1.27.33.82-.67,1.33-.66a2.87,2.87,0,0,1,.72.23,2.85,2.85,0,0,0,1.59-.34c2-.65,4,.54,5.71,1.68a1.92,1.92,0,0,0,1.09-1.69C278.13,79.69,277,79.25,276.68,79.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.26,91.05c-.38-.83-1.62-.46-2.39,0,.25-.51-.59-.91-1.11-.68s-.93.75-1.5.79a2.23,2.23,0,0,1-.72-.09,3.51,3.51,0,0,0-2.45.47c-.5.31-1.09.76-1.59.46s-.45-.82-.79-1.14c-.73-.69-2,.28-2.9-.13s-1.07-2.09-2.1-2.12c-.67,0-1.14.77-1.81.83-.85.08-1.33-1-1.37-1.85s0-1.88-.68-2.4l-2.45,4.52a2.16,2.16,0,0,0,1.47,1.63,1.93,1.93,0,0,1,.85.34c.23.23.26.59.43.86a1.94,1.94,0,0,0,1.65.67c1,0,2.09.06,2.68.83a3.57,3.57,0,0,0,.49.65,1.63,1.63,0,0,0,1.46,0,21.34,21.34,0,0,1,3.8-.86,3.56,3.56,0,0,1,1.49,0c.55.16,1.07.58,1.63.43a2.37,2.37,0,0,0,.87-.65,3.72,3.72,0,0,1,2.23-1,8.74,8.74,0,0,0,1.92-.15C282,92.31,282.52,91.64,282.26,91.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,95c-.17-.07-6.9-1.9-6.55,4.92s7.12,5.08,7.12,4.88S229.64,95,229.64,95Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,102.3s-.12.09-.31.19a1.17,1.17,0,0,1-.89.06,3,3,0,0,1-1.5-2.57,4.15,4.15,0,0,1,.25-1.72,1.41,1.41,0,0,1,.85-1,.62.62,0,0,1,.72.29c.1.19.06.33.1.34s.14-.12.07-.4a.73.73,0,0,0-.29-.42.91.91,0,0,0-.66-.14,1.67,1.67,0,0,0-1.19,1.12,3.94,3.94,0,0,0-.32,1.93,3.09,3.09,0,0,0,1.88,2.86,1.28,1.28,0,0,0,1.08-.24C228,102.46,228,102.31,228,102.3Z",
    style: {
      fill: "#723c31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.79,63.84S224.7,65.23,224,77.94s5.72,20,5.72,20l4.16-22,11.88-5.6,10.5-.12S254.05,63.7,242.79,63.84Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.74,107.68c0-4.83-.9-14.76-1.79-23.74a18.62,18.62,0,0,0-18.87-16.78l-1,0c-10.38.79-15.5,10.06-14.42,20.42l1.52,42.17,25.06,7.57-.43-17.93S264.8,117.67,264.74,107.68Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.85,119.4a23.26,23.26,0,0,1-13.1-3.46s3.22,7.13,13.17,6Z",
    style: {
      fill: "#723c31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,91.16a1.42,1.42,0,0,1-1.35,1.46,1.36,1.36,0,0,1-1.49-1.26,1.42,1.42,0,0,1,1.34-1.46A1.36,1.36,0,0,1,260.28,91.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,88.34c-.17.18-1.27-.6-2.8-.56s-2.65.82-2.82.63.09-.42.57-.78a3.88,3.88,0,0,1,2.26-.74,3.72,3.72,0,0,1,2.23.67C261,87.92,261.12,88.25,261,88.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.16,91.75a1.42,1.42,0,0,1-1.35,1.46A1.36,1.36,0,0,1,242.32,92a1.43,1.43,0,0,1,1.35-1.47A1.36,1.36,0,0,1,245.16,91.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.72,88.19c-.15.2-1.32-.45-2.85-.26s-2.54,1.11-2.73.94.05-.43.49-.84a3.89,3.89,0,0,1,2.16-1,3.69,3.69,0,0,1,2.29.43C245.6,87.78,245.8,88.09,245.72,88.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.59,100.71a9.78,9.78,0,0,1,2.48-.49c.39,0,.76-.14.82-.41a1.94,1.94,0,0,0-.28-1.15l-1.21-3c-1.69-4.22-2.92-7.69-2.75-7.76s1.68,3.3,3.37,7.52l1.16,3a2.23,2.23,0,0,1,.23,1.53,1,1,0,0,1-.63.59,2.47,2.47,0,0,1-.67.1A9.89,9.89,0,0,1,251.59,100.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.09,101.86c.25,0,.28,1.64,1.73,2.8s3.22.94,3.24,1.17-.39.33-1.14.37a4.12,4.12,0,0,1-2.7-.89,3.6,3.6,0,0,1-1.35-2.35C246.8,102.27,247,101.85,247.09,101.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.81,81.56c-.14.42-1.68.25-3.48.5s-3.24.77-3.49.4c-.11-.18.14-.58.72-1a5.76,5.76,0,0,1,2.57-1,5.91,5.91,0,0,1,2.74.27C245.53,81,245.87,81.36,245.81,81.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,84.43c-.27.35-1.33,0-2.61,0s-2.34.27-2.59-.09c-.12-.17,0-.52.51-.86a3.77,3.77,0,0,1,4.19,0C260.21,83.9,260.36,84.26,260.25,84.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.38,66.09c-3.53-1.39-7.11-.65-10.86-.1a17,17,0,0,0-8,3.18c-3.8,2.8-5.68,7.27-5.89,12a44,44,0,0,0,1.48,13.46l.37-.09a6.53,6.53,0,0,0-.05,3.48,2.25,2.25,0,0,0,2.75,1.51c1.26-.56,1.3-2.29,1.19-3.66a63.05,63.05,0,0,1,.39-14c.3-2.13.81-4.43,2.48-5.78,1.49-1.2,3.54-1.36,5.41-1.74,3.14-.64,6.09-2,9.24-2.58s7.16.08,9.19,2.55C258.35,70.58,254.92,67.48,251.38,66.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.36,118.87c-.12-.75-.84-1.25-1.46-1.69a21.06,21.06,0,0,1-4.59-4.35,3.29,3.29,0,0,0-.7-.74,3.4,3.4,0,0,0-.86-.41,11,11,0,0,1-5.62-5,21.89,21.89,0,0,1-1.89-7.1c-.09-.63-.18-1.26-.28-1.89-.32-2.18-.79-4.61-2.61-5.86l-2.93.53c-.95.55-.62,2,0,2.91s1.47,1.87,1.18,2.93a3.43,3.43,0,0,0-.32,1.11c.07,1,1.7,1.2,1.8,2.17,0,.58-.5,1.08-.46,1.66s.83,1,1.19,1.62c.51.82.1,2,.55,2.82s2,1.27,2.23,2.34c.16.7-.29,1.41-.26,2.13a3.2,3.2,0,0,0,.46,1.33c.48.92,1.06,1.93,2.07,2.18.52.13,1.08,0,1.61.15s1.1.51,1.68.67,1.36-.06,1.47-.65c.81.24,1.18,1.13,1.61,1.85s1.35,1.39,2,.93a2.84,2.84,0,0,0,2,2.12A1.71,1.71,0,0,0,237.36,118.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.77,106.69c-1-.75-2.29-1.38-2.61-2.6a5,5,0,0,0-.27-1c-.27-.5-.89-.71-1.22-1.17a5.5,5.5,0,0,1-.44-1.06,2.21,2.21,0,0,0-2.07-1.28,1.6,1.6,0,0,0-1.61-1.74c.15-2.13-1.13-4.06-2.36-5.8l-1.09-1.53a4.85,4.85,0,0,1-.52-.88,5.68,5.68,0,0,1-.23-1,36.4,36.4,0,0,0-3.28-8.15l-.86,8.86a7.8,7.8,0,0,0,0,2.81,2.61,2.61,0,0,0,1.82,2,2.62,2.62,0,0,1,1,.25c.62.43.32,1.38.39,2.13.14,1.75,2.45,2.6,2.83,4.31.27,1.25-.45,2.93.63,3.62.31.2.7.24,1,.41.7.37,1,1.23,1.47,1.84s1.74.78,1.92,0c.44.89,1.71.93,2.48,1.56a6.68,6.68,0,0,1,.91,1.08c.76.94,2.32,1.48,3.11.58S239.77,107.45,238.77,106.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,100.12a3.67,3.67,0,0,1-.38-.89l-.39-1.06a1.94,1.94,0,0,0-.31-.56c-.15-.17-.33-.27-.48-.18l-.33.18.07-.39A1.7,1.7,0,0,0,229,95.36a1.23,1.23,0,0,1-.38-.26.78.78,0,0,1-.2-.48,2.93,2.93,0,0,0-.06-.72,1.22,1.22,0,0,0-1-.82L227,93l.25-.35c.38-.52-.06-1.3-.38-2.08a3.54,3.54,0,0,1-.27-1.11,4.62,4.62,0,0,0-.1-1,.81.81,0,0,0-.54-.56,1.41,1.41,0,0,1-.79-.8,11.76,11.76,0,0,1-.18-1.84c-.11-.49-.49-.93-.82-.78l-.26.12,0-.29a7,7,0,0,0-.82-2.94c-.36-.64-.62-1-.59-1s.36.25.78.88a6.58,6.58,0,0,1,1,3l-.27-.17a.87.87,0,0,1,.94.21,1.86,1.86,0,0,1,.47.83,16.5,16.5,0,0,0,.19,1.78.93.93,0,0,0,.56.52,1.34,1.34,0,0,1,.81.86,4.82,4.82,0,0,1,.13,1.09,2.82,2.82,0,0,0,.24,1c.14.38.34.75.46,1.18a1.55,1.55,0,0,1-.15,1.38l-.18-.4a1.72,1.72,0,0,1,1.4,1.18,2.55,2.55,0,0,1,.07.83c0,.19.08.25.3.36a2.09,2.09,0,0,1,1.32,2.35l-.26-.2a.66.66,0,0,1,.55,0,1.16,1.16,0,0,1,.35.3,1.94,1.94,0,0,1,.33.68l.3,1.09A3,3,0,0,1,232,100.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,98.31a4.08,4.08,0,0,1-1.8-1.62c-.22-.31-.45-.65-.68-1a4.45,4.45,0,0,1-.65-1.31c-.07-.28,0-.58-.08-.72s-.21-.27-.44-.43a2.45,2.45,0,0,1-.95-1.53c-.05-.33,0-.57-.15-.68s-.39-.28-.6-.47a3.4,3.4,0,0,1-1-1.32,3.67,3.67,0,0,1-.26-1.44c0-.37-.29-.57-.53-.92a3.09,3.09,0,0,1-.58-1.72c0-.43.08-.65.11-.65a3.19,3.19,0,0,1,.09.63,3.31,3.31,0,0,0,.67,1.52c.11.14.24.25.39.42a1.21,1.21,0,0,1,.28.69A3.38,3.38,0,0,0,221.3,89a3.15,3.15,0,0,0,.85,1.12,5.38,5.38,0,0,1,.68.53,1.77,1.77,0,0,1,.26.92,2,2,0,0,0,.75,1.21,1.5,1.5,0,0,1,.61.69c.08.36,0,.57.07.77a4.27,4.27,0,0,0,.55,1.19c.22.37.42.72.62,1A14.38,14.38,0,0,0,227.18,98.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.79,83.33s-.27-.14-.5-.58a2.24,2.24,0,0,1-.25-.88,1.15,1.15,0,0,1,.07-.61.44.44,0,0,1,.83.06l.1.36-.39-.14a1.43,1.43,0,0,1-.86-1.26,3.2,3.2,0,0,1,.4-1.58l.05.29a1.62,1.62,0,0,1-.43-.71,3.82,3.82,0,0,1,0-1.91,1.91,1.91,0,0,1,.39-.86,1,1,0,0,1,.9-.33l-.26.18a4.45,4.45,0,0,1,.87-2c.33-.41.59-.57.62-.54a6.76,6.76,0,0,0-1.06,2.6l0,.23-.23,0a.51.51,0,0,0-.45.21,1.43,1.43,0,0,0-.26.65,3.55,3.55,0,0,0,0,1.65,1.18,1.18,0,0,0,.29.5l.14.13-.08.16a2.91,2.91,0,0,0-.38,1.34,1,1,0,0,0,.52.89l-.23.21c0,.11,0,0-.12.09a1.18,1.18,0,0,0-.07.42,2.5,2.5,0,0,0,.13.79C218.66,83.08,218.83,83.29,218.79,83.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.82,79.3a4.44,4.44,0,0,1-.89-1.72,9.77,9.77,0,0,1-.49-2.12,11.14,11.14,0,0,1-.07-1.31,2.31,2.31,0,0,1,.12-.76.91.91,0,0,1,.67-.64L223,73a4.76,4.76,0,0,1,.37-1.9,3.93,3.93,0,0,1,.34-.68.88.88,0,0,1,.35-.34.53.53,0,0,1,.3-.07.43.43,0,0,1,.36.24l-.48.18a2.7,2.7,0,0,1,.86-2.8,1.77,1.77,0,0,0,.44-1,2,2,0,0,1,.58-1,2.11,2.11,0,0,1,1.47-.58c.37,0,.55.12.54.14s-.2,0-.53,0a2.12,2.12,0,0,0-1.24.64,1.73,1.73,0,0,0-.43.84c0,.17-.07.37-.13.59a1.51,1.51,0,0,1-.37.62,2.25,2.25,0,0,0-.7,2.34l-.45.17c.1,0,.06-.07.06,0s0,.08,0,.06l0,0a.43.43,0,0,0-.15.15,5.59,5.59,0,0,0-.3.6,4.53,4.53,0,0,0-.34,1.71v.24h-.21c-.25,0-.4.51-.4.91s0,.86,0,1.25a12.4,12.4,0,0,0,.36,2.07C223.55,78.62,223.88,79.27,223.82,79.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.43,57.89a7.1,7.1,0,0,0-1.65.39,6.8,6.8,0,0,0-3,2.88l-.12.22-.23-.13a2.59,2.59,0,0,0-.93-.34,4.13,4.13,0,0,0-2.54.5,9.54,9.54,0,0,0-1.83,1.25,2.81,2.81,0,0,0-.87,1.16c-.12.32-.1.53-.14.53s-.12-.2,0-.58a2.75,2.75,0,0,1,.8-1.38A9.12,9.12,0,0,1,230.77,61a4.4,4.4,0,0,1,2.85-.58,2.91,2.91,0,0,1,1.12.41l-.35.08A6.51,6.51,0,0,1,237.66,58,2.32,2.32,0,0,1,239.43,57.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.15,198.7l-17.53-13.53s-18.22,24.1-20.78,29.48c-2.15,4.51-17.47,27.25-22.34,34.44l-13.43,10-.62,4.11-2.72,6.49s1.83,11.23,3.54,11.15c1.92-.08,1.59-4.66,1.59-4.66s5.3,4.38,6.68,5.76,4.28.35,3-1.49a29.19,29.19,0,0,0-2.82-3.41s2.13.83,3.14.13-.15-2.48-.15-2.48l-6.5-2,0-6.84s2.22-4.22,3.76-4,1.95,2.56,1.64,3c-1.14,1.7-3.64,6.66-3.64,6.66a1.63,1.63,0,0,0,2.3,1.05c1.7-.8,6.48-6.94,6.48-6.94s6.68-4.73,7.6-6.17c.67-1.06.93-4.34,1-6l41.07-39.28Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.44,448.21v1.05s30.14,7.22,29.05,15.43l-52,1.23.68-17.32C286,452,291.62,452,300.44,448.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.52,465.92l.07-4.16,51.26.35a3.31,3.31,0,0,1,.64,2.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.42,449.69c0,.25-1.22.52-2.36,1.48s-1.67,2.11-1.91,2,0-1.58,1.35-2.72S302.45,449.45,302.42,449.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.11,451.25c.09.24-.95.81-1.67,2s-.83,2.33-1.09,2.35-.59-1.39.34-2.83S308.08,451,308.11,451.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,457.35c-.23.08-.73-1.13-.26-2.59s1.59-2.16,1.72-2-.5,1-.88,2.23S312.23,457.3,312,457.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,465.4a2.55,2.55,0,0,0,.72,2.94,2.33,2.33,0,0,0,2.87.11c.77-.6,1.26-1.74,2.23-1.77.81,0,1.37.76,2,1.31,1.44,1.33,4.11,1.3,5.14-.37a5.39,5.39,0,0,1,.77-1.24c.85-.78,2.23-.22,3.09.55s1.66,1.78,2.8,1.89,2.34-.9,3.3-1.76,2.35-1.64,3.45-1c.69.41,1,1.23,1.57,1.77,1.4,1.28,3.71.46,5.11-.82a4.62,4.62,0,0,1,1.65-1.2c1.34-.41,2.61.68,3.74,1.52a5.57,5.57,0,0,0,2.45,1.17,2.63,2.63,0,0,0,2.47-.84c.26-.32.41-.7.65-1a2.5,2.5,0,0,1,2.9-.81c1.27.52,2.27,2.13,3.58,1.73,1.06-.33,1.28-1.72,1.27-2.83a1.56,1.56,0,0,0-.24-1,1.53,1.53,0,0,0-1.39-.35c-2.88.23-5.76.56-8.62,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,451.42s.11-.25.42-.6.83-.78,1.39-1.36a10.12,10.12,0,0,1,2.43-1.66,5.11,5.11,0,0,1,1.69-.57,3.93,3.93,0,0,1,1,0,1.34,1.34,0,0,1,.54.15.72.72,0,0,1,.38.57,2.2,2.2,0,0,1-1,1.74,7.46,7.46,0,0,1-1.45,1,8.28,8.28,0,0,1-2.79.94,7.55,7.55,0,0,1-2,.05c-.47-.06-.72-.14-.71-.17a24.45,24.45,0,0,0,2.62-.24,9.06,9.06,0,0,0,2.63-1,8.64,8.64,0,0,0,1.35-1c.43-.36.85-.83.81-1.29s-.8-.31-1.3-.25a5.24,5.24,0,0,0-1.54.49,11.22,11.22,0,0,0-2.39,1.5c-.62.57-1.17.95-1.51,1.25S304,451.44,304,451.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,451.75a11.23,11.23,0,0,1-.51-2.35,7.91,7.91,0,0,1-.15-2.65,3.42,3.42,0,0,1,.63-1.51,1.93,1.93,0,0,1,1.62-.85,1,1,0,0,1,.84.64,2.46,2.46,0,0,1,.12.9,8.68,8.68,0,0,1-.17,1.57,8.43,8.43,0,0,1-1,2.47,4.67,4.67,0,0,1-1.6,1.81c-.07-.06.61-.7,1.28-2a8.61,8.61,0,0,0,.81-2.38,7.91,7.91,0,0,0,.14-1.48c0-.52-.1-1-.51-1a1.44,1.44,0,0,0-1.16.64,3.16,3.16,0,0,0-.56,1.29,9,9,0,0,0,0,2.51A11,11,0,0,1,304,451.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.19,310.07a10.06,10.06,0,0,1,1.43-9.33,6.08,6.08,0,0,0,1.41-2.3c.13-.62,0-1.26.09-1.88s.5-1.3,1.12-1.32.94.4,1.44.54c1.19.34,2.19-1,2.6-2.13s.8-2.59,2-3,2.28.29,3.31-.14,1.35-1.72,1.63-2.81.91-2.35,2-2.39c.66,0,1.28.42,2,.39,1.3-.07,1.78-1.68,2.31-2.86.77-1.74,2.8-3.15,4.54-2.39a2.83,2.83,0,0,0,1.1.41c.74,0,1.17-.81,1.72-1.31,1.32-1.19,3.6-.46,4.62,1s1.13,3.35,1.21,5.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.56,306.67a38.45,38.45,0,0,1-10.66,6.67,6.43,6.43,0,0,1-4,.65,5.14,5.14,0,0,1-3.26-3.68c-1-3.3.14-6.94,2.1-9.73a33.43,33.43,0,0,1,7.4-6.94l13.07-10a17.44,17.44,0,0,1,5.17-3.06,5.78,5.78,0,0,1,5.66,1c1.71,1.64,1.84,4.4,1.27,6.73s-1.71,4.49-2.15,6.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.15,295.19a.74.74,0,0,1,0-.22c0-.14.06-.36.12-.63A22.64,22.64,0,0,1,173,292a34.19,34.19,0,0,0,1.18-3.73,8.26,8.26,0,0,0-.27-5,4.41,4.41,0,0,0-1.91-2.1,5.54,5.54,0,0,0-3.07-.58c-2.22.17-4.29,1.56-6.28,3.1-4.05,3.1-8.5,6.5-13.18,10.06a42.68,42.68,0,0,0-6.41,5.6,14,14,0,0,0-3.43,7,7.74,7.74,0,0,0,1.69,6.56,3.56,3.56,0,0,0,2.81,1.08,8.75,8.75,0,0,0,2.84-.79,39.1,39.1,0,0,0,7.92-4.42c.88-.62,1.53-1.14,2-1.49a6.11,6.11,0,0,1,.69-.53.9.9,0,0,1-.15.17c-.13.12-.29.26-.47.44-.43.38-1.07.92-1.93,1.58a37.22,37.22,0,0,1-7.9,4.59,9.2,9.2,0,0,1-3,.85,4,4,0,0,1-3.14-1.17,8.15,8.15,0,0,1-1.86-6.94,14.34,14.34,0,0,1,3.51-7.22,41.94,41.94,0,0,1,6.49-5.68l13.2-10c2-1.53,4.16-3,6.54-3.15a6,6,0,0,1,3.29.65,4.71,4.71,0,0,1,2.05,2.31,8.5,8.5,0,0,1,.22,5.22,32.54,32.54,0,0,1-1.27,3.73c-.38,1-.65,1.8-.8,2.34A6.11,6.11,0,0,1,172.15,295.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.07,308.49a7,7,0,0,1-3-2.44,7.12,7.12,0,0,1-1.72-3.48c.15-.06.81,1.53,2.13,3.16S153.16,308.36,153.07,308.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.69,305.31a4.72,4.72,0,0,1-2.63-1.94,4.83,4.83,0,0,1-1.26-3c.15,0,.58,1.34,1.67,2.71S155.77,305.18,155.69,305.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.24,309.58a5.66,5.66,0,0,1-2.26-1.91,5.44,5.44,0,0,1-1.42-2.59,19,19,0,0,1,1.82,2.26A16.38,16.38,0,0,1,148.24,309.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.56,302.82a2.18,2.18,0,0,1,.86.42,4.38,4.38,0,0,1,1.66,2,3.37,3.37,0,0,1,.17,1.86,1.85,1.85,0,0,1-.17.54.51.51,0,0,1-.35.25.57.57,0,0,1-.39-.11,3.78,3.78,0,0,1-.83-.77c-1-1.2-1.21-2.89-1.69-4.41-.25-.77-.61-1.51-.82-2.3A4.13,4.13,0,0,1,154,298c.14-.34.26-.8.82-1a.57.57,0,0,1,.6.43c.06.17.1.32.15.48a10.77,10.77,0,0,1,.32,1.79,9.38,9.38,0,0,1-.14,2.6,2.53,2.53,0,0,1-.28.92,17.83,17.83,0,0,0,.05-3.48,11,11,0,0,0-.37-1.71c0-.14-.09-.29-.14-.44s-.1-.14-.13-.14-.34.33-.42.64a3.71,3.71,0,0,0,.08,2.08c.2.73.56,1.46.82,2.27.5,1.62.71,3.2,1.58,4.29a3.74,3.74,0,0,0,.7.68c.14.06,0,.07.11,0a1.48,1.48,0,0,0,.13-.39,3.1,3.1,0,0,0-.1-1.64,4.54,4.54,0,0,0-1.43-2A8.47,8.47,0,0,1,155.56,302.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.52,292.68s0-.28,0-.76a3.41,3.41,0,0,0-.76-1.83,4.22,4.22,0,0,0-2.51-1.47,10,10,0,0,0-3.68.06,12.58,12.58,0,0,0-3.42,1.47,10.15,10.15,0,0,0-2.34,1.94,15.05,15.05,0,0,0-1.69,2.27,5.34,5.34,0,0,1,1.42-2.51,9.24,9.24,0,0,1,2.37-2.11,12,12,0,0,1,3.55-1.57,9.67,9.67,0,0,1,3.9,0,4.52,4.52,0,0,1,2.69,1.72,3.3,3.3,0,0,1,.68,2.05C172.69,292.43,172.55,292.69,172.52,292.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.12,281.22a8.12,8.12,0,0,1-.22,3.87,8.22,8.22,0,0,1-1.53,3.57c-.14-.06.55-1.64,1-3.69S172,281.21,172.12,281.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.44,314s8.77,30.39,9.83,35.57c.47,2.28,5.17,21.45,5.17,21.45l3.5,63.85h19.95l4.63-73-7.19-48.57S269.4,301.82,260.44,314Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.74,449.51l-2.21-48.75,25.85-1.42-2.89,50.43C291.46,452.59,286.73,452.39,278.74,449.51Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.85,406.64c0,.14-5.66.26-12.64.26s-12.65-.12-12.65-.26,5.66-.26,12.65-.26S301.85,406.49,301.85,406.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.85,410.52c0,.14-5.66.26-12.64.26s-12.65-.12-12.65-.26,5.66-.26,12.65-.26S301.85,410.38,301.85,410.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.34,236l-28.7,81.81s14.64,14,25.19,11.57,12.59-1.36,16.33-2.72,6.23-8.61,9.3-14.06,10.89-19.28,10.89-19.28l12.75,33.65h0c10.25-2.75,22.92-1.72,41.43-6.19,0,0-8.69-42.45-10.39-48.91s-3.57-27-3.57-27S217.23,231.4,211.34,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.08,280.11a6.16,6.16,0,0,1-.83.93c-.56.58-1.36,1.41-2.32,2.47a87.85,87.85,0,0,0-6.92,8.74,105.64,105.64,0,0,0-5.84,9.51l-1.6,3a6.66,6.66,0,0,1-.63,1.08,6,6,0,0,1,.45-1.17c.31-.74.81-1.79,1.45-3.07a83.32,83.32,0,0,1,5.74-9.63,69.45,69.45,0,0,1,7.09-8.7c1-1,1.83-1.83,2.44-2.36A4.92,4.92,0,0,1,255.08,280.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.29,259.68a10.31,10.31,0,0,1-2.47,1.14,12.05,12.05,0,0,1-2.89.68,7.72,7.72,0,0,1-3.64-.5,10.06,10.06,0,0,1-4.91-4.33,9.59,9.59,0,0,1-.84-1.81,2.05,2.05,0,0,1-.16-.72c.09,0,.4,1,1.31,2.34a10.47,10.47,0,0,0,4.79,4,9.28,9.28,0,0,0,6.23,0A21,21,0,0,1,275.29,259.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.16,275.62a3.28,3.28,0,0,1-1-.17,12.92,12.92,0,0,1-2.6-1,18.55,18.55,0,0,1-6.76-6.11A29.66,29.66,0,0,1,261,260c-.32-1.12-.54-2-.68-2.68a3.3,3.3,0,0,1-.14-1c.08,0,.44,1.38,1.18,3.58a33,33,0,0,0,3.87,8.13,19.5,19.5,0,0,0,6.51,6.07A28.79,28.79,0,0,0,275.16,275.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,327.66s-16.19,31.83-24.24,33.66c-12,2.74-16.46-5.79-17.68-7s-19.48-54.43-19.48-54.43,2.5-9.93,7.1-10.24,8,.87,8.62,2.41,12.41,19.74,12.41,19.74l-2.1,6Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.67,318.85a4.51,4.51,0,0,1-.42,1c-.3.65-.75,1.58-1.32,2.72-1.15,2.28-2.78,5.41-4.87,8.71a35.83,35.83,0,0,0-2.8,4.65,10,10,0,0,0-.61,4.31c.18,2.52.55,4.07.45,4.08a4.07,4.07,0,0,1-.32-1.06,23.89,23.89,0,0,1-.5-3,10,10,0,0,1,.53-4.5,31.57,31.57,0,0,1,2.81-4.75c2.07-3.28,3.75-6.38,5-8.61l1.47-2.64A4.19,4.19,0,0,1,187.67,318.85Z",
    style: {
      fill: "#723c31"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,326.87s.49-13.39,18.21-16l-12.47-19.82s-6.69-3.81-10.5-.55-4.6,9.37-4.6,9.37Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.75,307.88c0,.09-1.33-.09-3.44.08a19.3,19.3,0,0,0-7.83,2.35,17.26,17.26,0,0,0-6,5.54c-1.17,1.77-1.58,3-1.67,3a2.87,2.87,0,0,1,.24-.9,13.46,13.46,0,0,1,1.11-2.3,16.56,16.56,0,0,1,6-5.8,18.07,18.07,0,0,1,8.07-2.26,15.24,15.24,0,0,1,2.54.1A2.79,2.79,0,0,1,182.75,307.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.06,305.48c0,.1-1.27-.31-3.35-.32a15.91,15.91,0,0,0-7.73,2.06,22.3,22.3,0,0,0-6.17,5.2,10.11,10.11,0,0,0-1.68,2.9,5.4,5.4,0,0,1,1.39-3.12,20.34,20.34,0,0,1,6.21-5.43,15.13,15.13,0,0,1,8-2,12,12,0,0,1,2.48.37A2.44,2.44,0,0,1,181.06,305.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.61,188.46c0-1,16.82-39.91,18.47-42.55s20.45-17.15,20.45-17.15l5.55-2.81,12.6,5.43a11.91,11.91,0,0,0,4.58,1c3.27,0,6.43-1.29,7.78-4.28h0l-.12-3.27,7-2.81,4.62-.72,11-5s13.34,9.34,12.35,20.23L280.2,149s2.58,27.48,2.25,40.68,2.12,55.24,2.12,55.24-12.21,4-21.11,4.29-17.14-7.76-33-10.73S210.14,240,210.14,240l7.46-25.16.66-12.53-1.65-13.53L209,206.28l-26.39-12.87Z",
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.46,157.51a19.07,19.07,0,0,1-1.52-2,45.43,45.43,0,0,0-3.88-4.49,26.78,26.78,0,0,0-4.51-3.82,8,8,0,0,0-2.27-.84,3.53,3.53,0,0,1,2.45.51,22,22,0,0,1,4.7,3.78,31.5,31.5,0,0,1,3.81,4.65A8.61,8.61,0,0,1,218.46,157.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.42,182a8.12,8.12,0,0,1-.74,1.33c-.52.82-1.31,2-2.39,3.38a63.74,63.74,0,0,1-9.66,9.63c-4.15,3.32-7.45,6.85-10.21,9a29,29,0,0,1-3.37,2.41,10.14,10.14,0,0,1-1,.56,1.36,1.36,0,0,1-.36.16,10,10,0,0,1,1.23-.89,38.09,38.09,0,0,0,3.24-2.52c2.67-2.22,5.94-5.8,10.12-9.14a71.08,71.08,0,0,0,9.7-9.47c1.11-1.33,1.94-2.47,2.51-3.26A10.63,10.63,0,0,1,273.42,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,200l60-54.43s2.41,2.27,3.31,17l.5,7.4-54,40.49s-5-1.28-7.81,2.15a21.19,21.19,0,0,0-3.72,6.54l1.31-4.89.62-11.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.57,219.05a3.69,3.69,0,0,1-.94-.2c-.59-.15-1.44-.4-2.48-.72a75,75,0,0,1-8-2.93,38.36,38.36,0,0,1-7.43-4.23,21.24,21.24,0,0,1-2-1.66,3.71,3.71,0,0,1-.66-.69c.06-.07,1.08.82,2.87,2a45.94,45.94,0,0,0,7.43,4.05c3,1.33,5.88,2.33,7.93,3.06A25.64,25.64,0,0,1,245.57,219.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.87,157.78c-.1,0-.22-1.82-.81-4.69a63.26,63.26,0,0,0-3.45-10.92,86.65,86.65,0,0,0-5.08-10.29c-.74-1.26-1.36-2.28-1.8-3a6,6,0,0,1-.64-1.1,5.65,5.65,0,0,1,.81,1c.49.67,1.16,1.65,2,2.91A71.26,71.26,0,0,1,277.09,142,54.77,54.77,0,0,1,280.42,153a30.81,30.81,0,0,1,.43,3.47A5.54,5.54,0,0,1,280.87,157.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.36 172.12 217.83 185.18 222.07 172.75 198.73 157.51 192.36 172.12",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.06,166.15a3.55,3.55,0,0,1-.16,1c-.14.62-.36,1.5-.67,2.58-.6,2.17-1.56,5.13-2.67,8.37l-2.88,8.28c-.38,1.06-.72,1.91-1,2.48a3.24,3.24,0,0,1-.46.86c-.07,0,.44-1.32,1.1-3.46s1.62-5.1,2.74-8.33,2.12-6.17,2.81-8.3A31.27,31.27,0,0,1,224.06,166.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.61,202.62c-.05.13-6-2.37-13.35-5.6s-13.2-5.94-13.14-6.07,6,2.37,13.35,5.6S210.67,202.49,210.61,202.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.19,159.31l1.09,2.21-6.69,3.31-.86-1.75,1.51-5.05a2.4,2.4,0,0,0,0-2,1.06,1.06,0,0,0-1.6-.48,1.91,1.91,0,0,0-1.06,1.72l-2.38-.27a4.26,4.26,0,0,1,2.54-3.81c2-1,3.92-.48,4.83,1.35a4.68,4.68,0,0,1,.08,3.86l-.77,2.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.54,156.24c-1.61-3.27-.94-5.93,1.26-7s4.7,0,6.31,3.28.95,5.92-1.24,7S268.15,159.5,266.54,156.24Zm5.13-2.54c-1-2.07-2-2.57-2.74-2.19S268,153,269,155s2,2.57,2.76,2.19S272.7,155.78,271.67,153.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,164.81a8,8,0,0,1-1.89,1.11,40.41,40.41,0,0,1-10,3.34,8.61,8.61,0,0,1-2.18.25c0-.16,3.25-.78,7.15-2.09S243.94,164.67,244,164.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,124s.07.12.15.36a6.43,6.43,0,0,1,.25,1.09,8,8,0,0,1-.53,4.06,8.58,8.58,0,0,1-4.08,4.47,13.13,13.13,0,0,1-7.36.95,24.83,24.83,0,0,1-7.16-2,45,45,0,0,1-5.36-2.81c-1.47-.89-2.62-1.66-3.42-2.21a7.39,7.39,0,0,1-1.19-.89,9,9,0,0,1,1.3.72c.83.49,2,1.22,3.5,2.07a50.32,50.32,0,0,0,5.36,2.68,25.71,25.71,0,0,0,7,1.93,13,13,0,0,0,7.09-.86,8.43,8.43,0,0,0,4.62-8.09C257.16,124.54,257,124,257,124Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.44,138.72c-.1,0-.13-1.46-.69-3.73a29.56,29.56,0,0,0-3.62-8.33,66.92,66.92,0,0,0-5.45-7.35l-1.77-2.15a4.85,4.85,0,0,1-.6-.83s.3.22.76.69,1.11,1.17,1.89,2a52.73,52.73,0,0,1,5.61,7.32,26.82,26.82,0,0,1,3.54,8.52,19.17,19.17,0,0,1,.36,2.78A4,4,0,0,1,288.44,138.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.77,170.09c-1.71,6.3-4.26,12.74-6.14,18.81h0c.77.12.82.57,1.41.06,1.62-1.44,3.39-3,4.2-5a14,14,0,0,0,.75-4C223.28,176.62,223.56,173.28,222.77,170.09Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M227.13,211c4.88,2.77,10.63,3.59,16.24,3.67s11.21-.52,16.81-.33a17.73,17.73,0,0,1,7.57,1.55A7.45,7.45,0,0,1,272,221.9a1.37,1.37,0,0,1-.18.85,1.55,1.55,0,0,1-1.09.49,45.55,45.55,0,0,1-9.12.1,50.4,50.4,0,0,1-8.51-1c-6.51-1.49-12.23-5.5-18.74-7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ball--inject-183"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.51,432c0,.15-.71.48-1.62.91s-1.65.79-1.73.67.56-.69,1.51-1.14S316.47,431.88,316.51,432Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.3,
    cy: 443.09,
    r: 27.8,
    style: {
      fill: "#6B9ADF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.43 431.85 320.56 438.42 330.18 431.85 330.18 422.98 323.31 422.98 316.43 431.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.12 439.18 340.12 450.64 349.9 453.7 356.62 444.84 350.51 435.82 340.12 439.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,415.61v4l9,6,7.17-1.46C359.6,423.57,351,415.82,343.48,415.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.88 451.13 316.43 455.63 324.21 464.98 330.96 464.98 330.18 456.15 319.88 451.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,450.15a30.33,30.33,0,0,1-5.26,3.63,22.19,22.19,0,0,1-5.79,2.72c-.06-.13,2.51-1.35,5.53-3.17A57.28,57.28,0,0,1,341,450.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.61,439.46a4.31,4.31,0,0,1-1.93-.6,22.94,22.94,0,0,1-4.12-2.59,39.43,39.43,0,0,1-3.68-3.16,7.9,7.9,0,0,1-1.35-1.5c.11-.12,2.35,2,5.34,4.25a37.09,37.09,0,0,0,4,2.68C339.91,439.14,340.63,439.39,340.61,439.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.06,451.79a9.74,9.74,0,0,1-.11-2.08c0-1.28,0-3,0-5a38.52,38.52,0,0,1,.42-7.08,9,9,0,0,1,.11,2.08c0,1.28,0,3.05,0,5A37.86,37.86,0,0,1,320.06,451.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.51,435.82a41.68,41.68,0,0,1,.91-5.47,53.64,53.64,0,0,1,1-5.44,20.11,20.11,0,0,1-.5,5.53A22.93,22.93,0,0,1,350.51,435.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.48,419.62a70.18,70.18,0,0,1-6.9,1.8c-1.9.49-3.61,1-4.84,1.33a11.5,11.5,0,0,1-2,.56,25.1,25.1,0,0,1,6.74-2.39c1.91-.48,3.67-.83,4.94-1.06A8.06,8.06,0,0,1,343.48,419.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.1,444.37a36.15,36.15,0,0,1-5.36.46,23.83,23.83,0,0,1-5.39-.07,35.06,35.06,0,0,1,5.36-.45A23.51,23.51,0,0,1,367.1,444.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,464.44a41.9,41.9,0,0,1-.74-5.55,23.42,23.42,0,0,1-.23-5.61,41.9,41.9,0,0,1,.74,5.55A23.42,23.42,0,0,1,350.73,464.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,468.44a17.19,17.19,0,0,1-6.23-1.05,18.55,18.55,0,0,1-5.75-2.61c.07-.13,2.6,1.11,5.91,2.11S342.93,468.3,342.92,468.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.65,470.69v-2l7.75-4.87,7,.41C357.5,464.37,348.81,471.1,342.65,470.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,420.6c.14,0,.33.54.45,1.26s0,1.36-.12,1.35-.27-.56-.39-1.27S322.83,420.61,323,420.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9,455.73c0,.14-.63.13-1.34,0s-1.22-.29-1.24-.43.64-.26,1.35-.08S316.93,455.59,316.9,455.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,466.32c-.14,0-.19-.4-.12-.83s.26-.75.4-.73.19.4.12.83S324.1,466.34,324,466.32Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoot);
export default __webpack_public_path__ + "static/media/foot.dcd4082e2d8f83abf9077471b0074bb0.svg";
export { ForwardRef as ReactComponent };